
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage } from "element-plus";
import MiezzPageList from "@/models/MiezzPageList";
import DtoPageListSearchOrderPoolContainerTrailer from "@/models.machine/DtoPageListSearchOrderPoolContainerTrailer";
import DtoListItemOrderPoolContainerTrailer from "@/models.machine/DtoListItemOrderPoolContainerTrailer";
import { MiezzMenuTab } from "@/components/MiezzMenuTab.vue";
import { EnumOrderServiceType } from "@/models.machine/EnumOrderServiceType";
import ContainerTrailerPageList from "../Pool/ContainerTrailer/ContainerTrailerPageList.vue";
@Options({
  components: {
    ContainerTrailerPageList,
  },
})
export default class DeparturePortContainerTrailerPageList extends Vue {
  menuTab = new MiezzMenuTab();
  list = new MiezzPageList<
    DtoPageListSearchOrderPoolContainerTrailer,
    DtoListItemOrderPoolContainerTrailer,
    string
  >("ContainerTrailer_DeparturePort");
  powers: string[] = [];
  serviceType = EnumOrderServiceType.DeparturePort;

  created(): void {
    this.list.TopButtons = [
      {
        Code: "add",
        Label: "添加",
        Icon: "plus",
        Type: "text",
        Size: "small",
        PowerCode: "ContainerTrailer_DeparturePort_Add",
      },
      // {
      //   Code: "export",
      //   Label: "导出",
      //   Icon: "bottom",
      //   Type: "text",
      //   Size: "small",
      // },
    ];
    this.list.BottomButtons = [
      {
        Code: "export",
        Label: "导出",
        Icon: "bottom",
        Type: "text",
        Size: "small",
      },
      {
        Code: "CarryPlanTime",
        Label: "计划装柜时间",
        Icon: "edit",
        Type: "text",
        Size: "small",
      },
      {
        Code: "Addresses",
        Label: "装柜地址",
        Icon: "edit",
        Type: "text",
        Size: "small",
      },
      {
        Code: "ArrivalTime",
        Label: "实际装柜时间",
        Icon: "edit",
        Type: "text",
        Size: "small",
      },
      {
        Code: "SupplierLabel",
        Label: "供应商",
        Icon: "edit",
        Type: "text",
        Size: "small",
      },
      {
        Code: "CarryContainerAreaLabel",
        Label: "提柜地点",
        Icon: "edit",
        Type: "text",
        Size: "small",
      },
      {
        Code: "PlanCarryContainerTime",
        Label: "计划提柜时间",
        Icon: "edit",
        Type: "text",
        Size: "small",
      },
      {
        Code: "CarryContainerTime",
        Label: "实际提柜时间",
        Icon: "edit",
        Type: "text",
        Size: "small",
      },
      {
        Code: "StopAddress",
        Label: "经停地址",
        Icon: "edit",
        Type: "text",
        Size: "small",
      },
      {
        Code: "IntoPortWharfLabel",
        Label: "进港码头",
        Icon: "edit",
        Type: "text",
        Size: "small",
      },
      {
        Code: "BackContainerTime",
        Label: "进港时间",
        Icon: "edit",
        Type: "text",
        Size: "small",
      },
    ]
  }
}
